import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';

import { TranslateModule } from '@ngx-translate/core';

import { MgFormFieldModule } from '@app/src/app/form-field';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { PinComponent } from './Pin.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgFormFieldModule,
    MgSpinnerModule,

    // External dependencies
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    TranslateModule,
  ],
  declarations: [PinComponent],
  exports: [PinComponent],
})
export class PinModule {}
